// src/components/analytics/DebtAndSurplus.js
import React from 'react';
import './DebtAndSurplus.css';

const formatCurrency = (value) => {
  if (typeof value !== 'number' || isNaN(value)) return '';
  return value
    .toFixed(2)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    .replace('.', ',');
};

const DebtAndSurplus = ({ monthlyIncome, debtPayments, mortgagePayment, obligatoryExpenses }) => {
  // DTI = (ежемесячные обязательства / ежемесячный доход) * 100%
  const dti = monthlyIncome ? (debtPayments / monthlyIncome) * 100 : 0;
  // Остаток средств после выплат
  const surplus = monthlyIncome - (mortgagePayment + obligatoryExpenses);

  // Цвет шкалы
  const gaugeColor = dti < 36 ? '#36A2EB' : '#FF6384';
  const gaugeStyle = {
    width: `${Math.min(dti, 100)}%`,
    backgroundColor: gaugeColor,
    height: '20px',
    borderRadius: '10px',
  };

  return (
    <div className="debtAndSurplusWrapper">
      {/* Блок с ключевыми цифрами */}
      <div className="debtAndSurplusContent">
        <div className="infoItem">
          <span className="infoLabel">Ежемесячный доход:</span>
          <span className="infoValue">{formatCurrency(monthlyIncome)} ₽</span>
        </div>

        <div className="infoItem">
          <span className="infoLabel">Обязательные расходы:</span>
          <span className="infoValue">{formatCurrency(obligatoryExpenses)} ₽</span>
        </div>

        <div className="infoItem">
          <span className="infoLabel">Платёж по ипотеке:</span>
          <span className="infoValue">{formatCurrency(mortgagePayment)} ₽</span>
        </div>

        <div className="debtAndSurplusItem">
          <span className="itemLabel">Оставшиеся средства после выплаты ипотеки:</span>
          <span className="itemValue">{formatCurrency(surplus)} ₽</span>
        </div>

      </div>

      {/* DTI + шкала */}
      <div className="debtAndSurplusItem">
        <span className="itemLabel">Текущий DTI:</span>
        <span className="itemValue">{dti.toFixed(2)}%</span>
        <div className="dtiGauge">
          <div className="dtiBar" style={gaugeStyle} />
        </div>
        
        <h1 className="itemComment">
          {dti < 36
            ? '✅ Отлично! Ваш DTI ниже рекомендуемого показателя (36%).'
            : '❌ DTI выше 36% – рекомендуется снизить расходы и/или долговую нагрузку, а также увеличить доходы.'}
        </h1>
      </div>
    </div>
  );
};

export default DebtAndSurplus;